<template>
    <b-form id="offer_submit" @submit="onSubmit">
      <div class="alert alert-info" role="alert" v-if="$currentUser.department == 'adkey'">
        <h5>Правила именования:</h5>
        <p>
          Вариант А - приложение рекла или веб оффер<br/>
          Name app [iOS/Android/Web/Nutra/SEO] Geo, например Liga Stavok [iOS] RU
        </p>
        <p>
          Вариант Б - оффер из ПП<br/>
          В самом конце обязательно указываем название партнёрки, например Vulkan [Android] CH – CPABRO
        </p>
        <p>
          Вариант В - наше приложение (заводится в CRM Полиной)<br/>
          [Название ПП] название оффера гео CPA/CPI ставка и валюта, например [Ultra Partners] VegasPlus CH CPA 125eur
        </p>
      </div>
        <div class="row">
            <div class="col-sm-12">
                <label>Аффайз ID</label>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-11">
                <b-form-group>
                    <v-select :options="options" :filterable="false" v-model="offer.item.affise_id" @search="onSearch">
                        <template slot="no-options">
                            Начните вводить ID...
                        </template>
                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                {{ option.id }}
                                {{ option.title }}
                            </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                                {{ option.id ? option.id : option.label }}
                            </div>
                        </template>
                    </v-select>
                </b-form-group>
            </div>
            <div class="col-sm-1 pt-2" v-bind:style="[isMobile ? {'padding-left': '15px', 'padding-bottom': '10px', 'padding-top': '0px !important'} : {'padding-left': '0px'}]">
                <div style="cursor: pointer;"
                     align="center"
                     v-on:click="fillFields()">
                    <i class="icon-fa icon-fa-refresh"></i>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12">
                <b-form-group label="Аффайз платформа">
                    <v-select :options="affisePlatforms" v-model="offer.item.affise_platform">
                        <span slot="no-options">Совпадений не найдено.</span>
                    </v-select>
                    <span class=" alert-danger" v-if="submitted && !offer.item.affise_platform">Выберите Аффайз платформу.</span>
                </b-form-group>
                <b-form-group label="Название"
                              label-for="title">
                    <b-form-input id="title"
                                  type="text"
                                  v-model="offer.item.title">
                    </b-form-input>
                    <span class=" alert-danger" v-if="submitted && !offer.item.title">Заполните название.</span>
                </b-form-group>
                <b-form-group label="Тип">
                    <v-select :options="types"
                              :searchable="false"
                              required
                              v-model="offer.item.type">
                    </v-select>
                    <span class=" alert-danger" v-if="submitted && !offer.item.type">Укажите тип.</span>

                </b-form-group>
                <b-form-group label="Гео">
                    <v-select :options="countries" required v-model="offer.item.geo" multiple>
                        <span slot="no-options">Совпадений не найдено.</span>
                    </v-select>
                    <span class=" alert-danger" v-if="submitted && offer.item.geo.length === 0">Добавьте страну.</span>

                </b-form-group>
                <b-form-group label="Платформа">
                    <v-select :options="platforms" required v-model="offer.item.platforms" multiple>
                        <span slot="no-options">Совпадений не найдено.</span>
                    </v-select>
                    <span class=" alert-danger"
                          v-if="submitted && offer.item.platforms.length === 0">Добавьте платформу.</span>

                </b-form-group>
                <b-form-group v-if="$currentUser.department == 'agency'" label="Вертикаль">
                    <v-select :options="topics"
                              v-model="offer.item.topic">
                        <span slot="no-options">Совпадений не найдено.</span>
                    </v-select>
                    <span class=" alert-danger" v-if="submitted && !offer.item.topic">Заполните вертикаль.</span>
                </b-form-group>
                <b-form-group label="Рекламодатель">
                  <v-select :options="advertisers" :reduce="advertiser => advertiser.value" required v-model="offer.item.advertiser_id">
                    <span slot="no-options">Совпадений не найдено.</span>
                  </v-select>
                  <span class=" alert-danger"
                        v-if="submitted && !offer.item.advertiser_id">Выберите рекламодателя.</span>
                </b-form-group>
                <b-form-group label="Трекер">
                    <v-select :options="trackers"
                              v-model="offer.item.tracker">
                        <span slot="no-options">Совпадений не найдено.</span>
                    </v-select>

                </b-form-group>
                <b-form-group label="Валюта оффера">
                    <v-select :options="currency" :searchable="false" required v-model="offer.item.currency">
                        <span slot="no-options">Совпадений не найдено.</span>
                    </v-select>
                    <span class=" alert-danger" v-if="submitted && !offer.item.currency">Добавьте валюту.</span>
                </b-form-group>
                <b-button type="submit" class="float-right"
                          variant="primary">Сохранить и выйти
                </b-button>
            </div>
        </div>

        <div class="form-errors"></div>
    </b-form>
</template>
<script>
    import OffersService from '../../../services/offersDataService';
    import AdvertiserFormMixin from "../mixins/Advertiser/advertiserFormMixin";
    import {th} from "../../../services/customLocaleDatepicker";

    export default {
        name: 'EditOfferModal',
        components: {
            OffersService: OffersService
        },
        mixins:[AdvertiserFormMixin],
        props: {
            offer: {
                default: function () {
                    return {
                        title: null,
                        geo: [],
                        currency: null,
                        affise_platform: 'Zorka Network',
                        platforms: [],
                        tracker: null,
                        affise_id: null,
                        advertiser_id: null,
                        manager_id: null,
                        type: null,
                        topic: null
                    }
                }
            },
        },
        data() {
            return {
                countries: [],
                topics: [],
                types: [
                    {
                        label: 'Белый',
                        value: 'white'
                    },
                    {
                        label: 'Серый',
                        value: 'grey'
                    },
                    {
                      label: 'Seo',
                      value: 'seo'
                    },
                    {
                      label: 'InfoBiz',
                      value: 'infoBiz'
                    },
                    {
                      label: 'Affiliate',
                      value: 'Affiliate'
                    }
                ],
                affisePlatforms: [],
                platforms: [],
                trackers: [],
                currency: [],
                options: [this.offer.item.id],
                searchOffer: null,
                submitted: false,
                isMobile: false,
                window: {
                    width: 0,
                    height: 0
                },
            }
        },
        methods: {
            onSubmit(evt) {
                this.submitted = true;

                if (!this.offer.item.title || this.offer.item.geo.length == 0 || this.offer.item.platforms.length == 0 || !this.offer.item.advertiser_id || !this.offer.item.currency || !this.offer.item.affise_platform || !this.offer.item.type) {
                    evt.preventDefault();

                    return;
                }

                if (this.$currentUser.department === 'agency' && !this.offer.item.topic) {
                    evt.preventDefault();

                    return;
                }

                this.offer.item.affise_id = this.offer.item.affise_id ? this.offer.item.affise_id.id : null;

                OffersService.updateOffer(this.offer.item)
                    .then(function (response) {
                    })
            },
            handleResize() {
                this.window.width = window.innerWidth;
                this.window.height = window.innerHeight;

                if (this.window.width < 577) {
                    this.isMobile = true
                } else {
                    this.isMobile = false
                }
            },
            getCountries() {
                OffersService.getCountries()
                    .then(function (response) {
                        let countries = [];

                        response.forEach(function (item) {
                            countries.push(item.code);
                        });

                        this.countries = countries;
                    }.bind(this))
            },
            getAffisePlatforms() {
                OffersService.getAffisePlatforms()
                    .then(function (response) {

                        this.affisePlatforms = response;
                    }.bind(this))
            },
            getPlatforms() {
                OffersService.getPlatforms()
                    .then(function (response) {

                        this.platforms = response;
                    }.bind(this))
            },
            getTrackers() {
                OffersService.getTrackers()
                    .then(function (response) {

                        this.trackers = response;
                    }.bind(this))
            },
            getTopics() {
                OffersService.getTopics()
                    .then(function (response) {

                        this.topics = response;
                    }.bind(this))
            },
            getCurrency() {
                OffersService.getCurrency()
                    .then(function (response) {

                        this.currency = response;
                    }.bind(this))
            },
            onSearch(search, loading) {
                this.options = [];

                if (search.length > 2) {
                    loading(true);

                    let affisePlatform = this.offer.item.affise_platform;

                    if (!affisePlatform) {
                        affisePlatform = 'Zorka Network';
                    }

                    OffersService.searchOffer(search, affisePlatform)
                        .then(function (response) {

                            if (response.offer) {
                                response.offer.label = response.offer.title
                                this.options = [response.offer]
                                this.searchOffer = response.offer
                                // this.offer.item.title = this.searchOffer.title;
                            }
                            loading(false);
                        }.bind(this), 350)
                }
            },
            fillFields() {
                if (this.searchOffer) {
                    let countries = [];
                    let platforms = [];

                    this.searchOffer.payments.forEach(function (item) {
                        countries = countries.concat(item.countries)
                        platforms = platforms.concat(item.os)
                    }.bind(this));

                    let uniqueCountries = [];

                    countries.forEach(function (el) {
                        if (uniqueCountries.indexOf(el) === -1) {
                            uniqueCountries.push(el)
                        }
                    });

                    let uniquePlatforms = [];

                    platforms.forEach(function (el) {
                        if (uniquePlatforms.indexOf(el) === -1 && this.platforms.indexOf(el) > -1) {
                            uniquePlatforms.push(el)
                        }
                    }.bind(this));

                    this.offer.item.geo = uniqueCountries;
                    this.offer.item.platforms = uniquePlatforms;

                }
            },

            //метод не используется MBR-253
            getAdvertiser(id) {
                let affisePlatform = this.offer.item.affise_platform;

                if (!affisePlatform) {
                    affisePlatform = 'Zorka Network';
                }
                OffersService.getAdvertiser(id, affisePlatform)
                    .then(function (response) {
                        this.offer.item.advertiser = response.advertiser.title;
                        this.offer.item.manager_id = response.advertiser.manager_obj.id;
                    }.bind(this))
            }
        },
        watch: {
            'offer.item.affise_id': function (newVal, oldVal) {
                if (newVal.id != oldVal) {
                    this.offer.item.title = this.searchOffer.title;
                }
            }
        },
        created() {
            window.addEventListener('resize', this.handleResize)
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize)
        },
        beforeMount() {
            this.getCountries();
            this.getCurrency();
            this.getTrackers();
            this.getPlatforms();
            this.getAffisePlatforms();
            this.getAdvertisers();

            if (this.$currentUser.department == 'agency') {
                this.getTopics();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/views/front/modals/EditOfferModal.vue